import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Navbar from "@/components/site/Navbar";
import Hero from "@/components/site/Hero";
import CartaResponsabilidad from "@/components/site/CartaResponsabilidad";
import FirmaCarta from "@/components/site/FirmaCarta";
import Destacadas from "@/components/site/Destacadas";
import QuienesSomos from "@/components/site/QuienesSomos";
import Stats from "@/components/site/Stats";
import PolicyBriefs from "@/components/site/PolicyBriefs";
import Sistemas from "@/components/site/Sistemas";
import Noticias from "@/components/site/Noticias";
import Contacto from "@/components/site/Contacto";
import Newsletter from "@/components/site/Newsletter";
import Footer from "@/components/site/Footer";
import BackToTop from "@/components/site/BackToTop";
import CookieBanner from "@/components/site/CookieBanner";
import AvisoLegal from "@/pages/legal/AvisoLegal";
import Privacidad from "@/pages/legal/Privacidad";
import Cookies from "@/pages/legal/Cookies";
import Baja from "@/pages/legal/Baja";
import Login from "@/pages/admin/Login";
import Inbox from "@/pages/admin/Inbox";
import Prensa from "@/pages/press/Prensa";
import Auxilia from "@/pages/auxilia/Auxilia";
import MapaEspana from "@/pages/mapa/MapaEspana";
import { AuthProvider } from "@/context/AuthContext";
import useSeo from "@/hooks/useSeo";

const Home = () => {
  useSeo({
    title: "España Eficiente (E²): reforma y transparencia",
    description:
      "Iniciativa independiente de reforma y transparencia en España: más de 60 Policy Briefs y propuestas basadas en datos y fuentes oficiales sobre economía, sanidad y empleo.",
    path: "",
  });
  return (
  <div className="bg-[#FAFAFA]">
    <Navbar />
    <main>
      <Hero />
      <CartaResponsabilidad />
      <FirmaCarta />
      <Destacadas />
      <Stats />
      <QuienesSomos />
      <PolicyBriefs />
      <Sistemas />
      <Noticias />
      <Contacto />
      <Newsletter />
    </main>
    <Footer />
    <BackToTop />
  </div>
  );
};

function App() {
  return (
    <div className="App">
      <Toaster position="top-center" richColors />
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/aviso-legal" element={<AvisoLegal />} />
            <Route path="/privacidad" element={<Privacidad />} />
            <Route path="/cookies" element={<Cookies />} />
            <Route path="/baja" element={<Baja />} />
            <Route path="/prensa" element={<Prensa />} />
            <Route path="/auxilia" element={<Auxilia />} />
            <Route path="/mapa" element={<MapaEspana />} />
            <Route path="/login" element={<Login />} />
            <Route path="/admin" element={<Inbox />} />
          </Routes>
          <CookieBanner />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
